<template>
  <div>
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script setup>
  import { useRoute } from 'vue-router';
  const route = useRoute();
</script>

<style scoped>
#app {
  font-family: '微软雅黑';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0 auto;
}

</style>
